module.exports = __webpack_public_path__ + "img/piece-locked-4.3aad73d7.svg";